import * as React from 'react';
import styles from './index.module.less';
import CompRecommendItem from './RecommendItem';
import type { IRecommendDataItem } from '../../model';
import CompRecommendProduct from './RecommendProduct';
import { useTranslation } from '@/modules/ReoI18n';
import type { IRecommendData } from '@/interface';
interface IProps {
    recommendProduct: IRecommendData;
}

const CompFourSuggestion: React.FC<IProps> = (props) => {
    const { t } = useTranslation();
    // 推荐产品和底部链接
    const productLineData: IRecommendDataItem[] = React.useMemo(() => {
        return [1, 2, 3, 4, 5, 6].map((item) => ({
            title: t('page-not-found:product-line-data-title-' + item),
            link: t('page-not-found:product-line-data-link-' + item),
        }));
    }, [t]);
    const productLineLink: IRecommendDataItem[] = React.useMemo(() => {
        return [1].map((item) => ({
            title: t('page-not-found:product-line-link-title-' + item),
            link: t('page-not-found:product-line-link-' + item),
        }));
    }, [t]);
    // 推荐热门关键词和底部链接
    const reolinkHotData: IRecommendDataItem[] = React.useMemo(() => {
        return [1, 2, 3, 4].map((item) => ({
            title: t('page-not-found:reolink-hot-data-title-' + item),
            link: t('page-not-found:reolink-hot-data-link-' + item),
        }));
    }, [t]);
    const reolinkHotLink: IRecommendDataItem[] = React.useMemo(() => {
        return [1].map((item) => ({
            title: t('page-not-found:reolink-hot-link-title-' + item),
            link: t('page-not-found:reolink-hot-link-' + item),
        }));
    }, [t]);
    return (
        <div className={ `${styles['four-suggestion']}` }>
            <CompRecommendItem
                title={ t('page-not-found:product-line-title') }
                dataList={ productLineData }
                linkList={ productLineLink }
            />
            <CompRecommendItem
                title={ t('page-not-found:reolink-hot-title') }
                dataList={ reolinkHotData }
                linkList={ reolinkHotLink }
            />
            {props.recommendProduct.data.length > 0 && props.recommendProduct.type === 'customize' && (
                <CompRecommendProduct
                    title={ props.recommendProduct.data[0].title }
                    image={ props.recommendProduct.data[0].image }
                    desc={ props.recommendProduct.data[0].description }
                    link={ props.recommendProduct.data[0].href }
                    linkText={ props.recommendProduct.data[0].linkText }
                />
            )}
        </div>
    );
};
export default CompFourSuggestion;
